import qs from 'query-string'

const whatsHappening = (href: string): string => {
  const params = qs.parseUrl(href)
  const paramsOrder = ['topics', 'experiences', 'range', 'types']
  Object.keys(params.query).forEach(key => {
    const val = params.query[key]
    if (Array.isArray(val)) {
      val.sort()
    }
  })
  const search = qs.stringify(params.query, {
    sort: (q1, q2) => paramsOrder.indexOf(q1) - paramsOrder.indexOf(q2),
  })

  return search ? `${params.url}?${search}` : params.url
}

export default whatsHappening
